function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/form-control.ts
import { formAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $fg = cssVar("form-control-color");
var baseStyleRequiredIndicator = defineStyle(_defineProperty(_defineProperty(_defineProperty({
  marginStart: "1"
}, $fg.variable, "colors.red.500"), "_dark", _defineProperty({}, $fg.variable, "colors.red.300")), "color", $fg.reference));
var baseStyleHelperText = defineStyle(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  mt: "2"
}, $fg.variable, "colors.gray.600"), "_dark", _defineProperty({}, $fg.variable, "colors.whiteAlpha.600")), "color", $fg.reference), "lineHeight", "normal"), "fontSize", "sm"));
var baseStyle = definePartsStyle({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: baseStyleRequiredIndicator,
  helperText: baseStyleHelperText
});
var formTheme = defineMultiStyleConfig({
  baseStyle: baseStyle
});
export { formTheme };